import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "contexts/AuthContext";
import { jwtDecode } from 'jwt-decode';
import { getAppApiURL } from 'utils/serverUrl';

import localStorageUtil from "utils/localStorageUtil";

function Auth() {
  const navigate = useNavigate();
  const { setToken, setRedirectPathCode, setAuthProcess } = useAuth();
  const checkEnvironment = process.env.REACT_APP_RUNNING_CONTEXT;

  useEffect(() => {
    const fetchAuthData = async () => {
      try {
        const currentUrl = new URL(window.location.href);
        const code = currentUrl.searchParams.get("code");
        const currentPostLoginRedirectPath =
          currentUrl.search.match(/\?(\/[^?&]+)/);

        const vIdFromUrl = currentUrl.searchParams.get("v_id");
        const vIdFromSession = sessionStorage.getItem("pendingInvitationId");
        const vIdMatches = vIdFromUrl || vIdFromSession || "";

        if (code) {
          const response = await fetch(`${getAppApiURL()}/auth/${code}`);
          const data = await response.json();

          if (data.success) {
            const currentClientId = localStorage.getItem("clientId");
            const newClientId = jwtDecode(data.token).id;
            setToken(data.token);
            localStorage.setItem("token", data.token);
            localStorage.setItem("refreshToken", data.refresh_token);

            if (newClientId !== currentClientId) {
              localStorage.setItem("clientId", newClientId);
              localStorage.removeItem("selectBreadcrumbs");
            }

            const currentSelectBreadcrumbs =
              localStorage.getItem("selectBreadcrumbs");

            const storedSelectedRealmData = localStorageUtil.getItemField(
              "selectBreadcrumbs",
              "realm",
            );
            const storedSelectedOrgData = localStorageUtil.getItemField(
              "selectBreadcrumbs",
              "orgs",
            );
            const storedSelectedSiteData = localStorageUtil.getItemField(
              "selectBreadcrumbs",
              "site",
            );

            const isEmptyRealm =
              !storedSelectedRealmData ||
              Object.keys(storedSelectedRealmData).length === 0;
            const isEmptyOrg =
              !storedSelectedOrgData ||
              Object.keys(storedSelectedOrgData).length === 0;
            const isEmptySite =
              !storedSelectedSiteData ||
              Object.keys(storedSelectedSiteData).length === 0;

            // 如果使用者直接貼上網址到網頁, 會判斷麵包屑是否有值, 有值就直接進入對應頁面
            // 沒有值就進入 level view

            // 如果使用者直接貼上網址是邀請網址 invitation, 會直接進入邀請頁面, 不判斷麵包屑對應關係

            // 如果使用者照正常流程登入, 會判斷麵包屑階層關係, 進入對應的 level view

            if (
              !vIdMatches &&
              currentPostLoginRedirectPath !== null &&
              ((checkEnvironment === "cloud" &&
                !isEmptyRealm &&
                !isEmptyOrg &&
                !isEmptySite) ||
                (checkEnvironment === "premises" &&
                  !isEmptyRealm &&
                  !isEmptySite))
            ) {
              setAuthProcess("postLogin");
              navigate(currentPostLoginRedirectPath[1]);
            } else if (vIdMatches) {
              setRedirectPathCode(vIdMatches);
              setAuthProcess("postLogin");
              navigate(`/invitation?v_id=${encodeURIComponent(vIdMatches)}`);
            } else {
              if (checkEnvironment === "cloud") {
                setAuthProcess("login");
                if (
                  currentSelectBreadcrumbs === null ||
                  (isEmptyRealm && isEmptyOrg && isEmptySite)
                ) {
                  navigate("/realms");
                } else if (!isEmptyRealm && isEmptyOrg && isEmptySite) {
                  if (storedSelectedRealmData.hasManageOrg === true) {
                    navigate("/msp/organizations")
                  } else {
                    navigate("/org/sites")
                  }
                } else if (!isEmptyRealm && !isEmptyOrg && isEmptySite) {
                  navigate("/org/sites")
                } else {
                  navigate("/site/dashboard")
                }
              } else if (checkEnvironment === "premises") {
                setAuthProcess("login");
                if (!isEmptyRealm && !isEmptySite) {
                  navigate("/site/dashboard")
                } else {
                  navigate("/org/sites")
                }
              }
            }

          } else {
            console.error('Authentication failed:', data);
          }
        } else {
          console.error('Code not found in URL');
        }
      } catch (error) {
        console.error('Error during fetch:', error);
      }
    };

    fetchAuthData();
  }, [navigate, setToken]);

  return <div>Loading...</div>;
}

export default Auth;
